import React, { useState } from "react";
import Sidebar from "../components/Sidebar";
import Rightarrow from "../assets/icons/Rightarrow";
import {
  storeLoginData,
  getLoginData,
  removeLoginData,
  isLoggedIn,
} from "../utils/loginSession";

const Profile = () => {
  const [profileImage, setProfileImage] = useState(null);
  const placeholderImage = "https://via.placeholder.com/150";
  const user = getLoginData()?.user;
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setProfileImage(imageUrl); // Set uploaded image as profileImage
    }
  };

  return (
    <React.Fragment>
      <section>
        <div className="wrapper">
          <div className="account_grid">
            <Sidebar />
            <div className="page-content">
              <p className="page-content-title">Profile Information</p>
              <form>
                <div className="profile-page">
                  <div className="img-container">
                    <div
                      src={profileImage || placeholderImage}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                        fontSize: "40px",
                      }}
                      alt="Profile"
                      className="profile-img"
                    >
                      {user?.full_name[0]}
                    </div>
                    {/* <div style={{ display: "flex" }}>
                      <label className="profile-label">
                        {profileImage ? "Change Image" : "Upload Image"}
                        <input
                          type="file"
                          accept="image/*"
                          className="hidden"
                          onChange={handleImageChange}
                        />
                      </label>
                    </div> */}
                  </div>
                  <div className="field-group">
                    <div className="fields-container">
                      <div className="form_group">
                        <label htmlFor="name">Name</label>
                        <input
                          type="text"
                          name=""
                          id="name"
                          value={user?.full_name}
                          placeholder="Enter your name"
                        />
                      </div>
                      <div className="form_group">
                        <label htmlFor="email">Email</label>
                        <input
                          type="email"
                          name=""
                          value={user?.email}
                          id="email"
                          placeholder="Enter your email"
                        />
                      </div>

                      {/* <div className="form_group">
                        <label htmlFor="homeadd">Home Address</label>
                        <input
                          type="text"
                          name=""
                          id="homeadd"
                          placeholder="Enter your address"
                        />
                      </div>
                      <div className="form_group">
                        <label htmlFor="hoph">Home Ph no.</label>
                        <input
                          type="number"
                          name=""
                          id="hoph"
                          placeholder="Enter your number"
                        />
                      </div>
                      <div className="form_group">
                        <label htmlFor="ofadd">Office Address</label>
                        <input
                          type="text"
                          name=""
                          id="ofadd"
                          placeholder="Enter your address"
                        />
                      </div>
                      <div className="form_group">
                        <label htmlFor="ofphone">Office Ph no.</label>
                        <input
                          type="number"
                          name=""
                          id="ofphone"
                          placeholder="Enter your number"
                        />
                      </div> */}
                    </div>
                    {/* <button type="submit" className="btn btn-primary mt-4">
                      Save & Continue <Rightarrow />
                    </button> */}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
};

export default Profile;
